<div class="kt-portlet">
  <div class="kt-portlet__head">
    <div class="kt-portlet__head-label">
      <div class="kt-portlet__head-title"> Price Negotiations </div>
    </div>
    <div class="kt-portlet__head-toolbar">
      <button
        class="btn btn-default"
        (click)="showFilter = !showFilter"
        [translate]="'BUTTONS.FILTER'"
      >
        <i class="fas fa-filter"></i> Filter
      </button>
    </div>
  </div>
  <div class="kt-portlet__body" *ngIf="qRecord">
    <table class="table table-striped">
      <thead>
        <tr *ngIf="showFilter">
          <td colspan="5">
            <div class="kt-widget filter">
              <div class="form-group">
                <label for="">Product</label>
                <input
                  type="text"
                  class="form-control"
                  (keyup.enter)="getRecords(false, 1)"
                  [(ngModel)]="filter.product"
                />
              </div>
              <div class="form-group">
                <label for="">Client</label>
                <input
                  type="text"
                  class="form-control"
                  (keyup.enter)="getRecords(false, 1)"
                  [(ngModel)]="filter.client"
                />
              </div>
              <div class="form-group">
                <label for="">Date</label>
                <input
                  type="date"
                  class="form-control"
                  (keyup.enter)="getRecords(false, 1)"
                  [(ngModel)]="filter.date"
                />
              </div>
              <div class="form-group">
                <label for="">&nbsp;</label> <br />
                <button
                  class="btn btn-outline-primary"
                  (click)="getRecords(false, 1)"
                  type="button"
                >
                  <i class="fas fa-search"></i> </button
                >&nbsp;
                <button
                  class="btn btn-default"
                  (click)="filter = {}; getRecords(false, 1)"
                >
                  <i class="fas fa-eraser"></i>
                </button>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th [translate]="'TITLES.DATE_SENT'"></th>
          <th [translate]="'LABELS.PRODUCT_NAME'"></th>
          <th [translate]="'TITLES.CLIENT_NAME'"></th>
          <th [translate]="'TITLES.COUNTRY'"></th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading">
          <td colspan="4" class="text-center">
            <br />
            <h6 [translate]="'GENERAL.GETTING_RECORDS'">
              <i class="fas fa-spinner fa-spin"></i> Getting records...
            </h6>
            <br />
          </td>
        </tr>
        <tr *ngFor="let q of qRecord.data; let i = index">
          <td>
            {{ q.created_at | date: 'mediumDate' }}
          </td>
          <td class="text-capitalize">
            <a
              [routerLink]="['/quotes', q.quotation.rfq.id, 'view']"
              [queryParams]="{ v: 'quotations' }"
              routerLinkActive="router-link-active"
            >
              {{ q.quotation.rfq.product_name }}
            </a>
          </td>
          <td class="text-capitalize">
            <span
              *ngIf="
                q.quotation.rfq.user_account &&
                q.quotation.rfq.user_account.firstname
              "
            >
              <a
                href="javascript:;"
                [routerLink]="[
                  '/clients',
                  q.quotation.rfq.user_account.id,
                  'profile',
                ]"
                routerLinkActive="router-link-active"
              >
                {{
                  q.quotation.rfq.user_account.firstname +
                    ' ' +
                    q.quotation.rfq.user_account.lastname
                }}
              </a>
            </span>
          </td>
          <td>
            {{ q.quotation.country }}
          </td>
          <td class="text-right">
            <span
              class="kt-badge kt-badge--info kt-badge--inline kt-badge--pill pull-right"
              *ngIf="q.status == 1"
              >Active</span
            >
            <span
              class="
                kt-badge kt-badge--success kt-badge--inline kt-badge--pill pull-right
              "
              *ngIf="q.status == 4"
              >Quote Updated</span
            >
          </td>
        </tr>
      </tbody>
    </table>

    <mat-paginator
      [length]="qRecord.total"
      [pageSize]="qRecord.per_page"
      [pageSizeOptions]="pageSizeOptions"
      (page)="getRecords($event)"
    >
    </mat-paginator>
  </div>
</div>
